<kendo-scheduler [editable]="true" [selectedViewIndex]="defaultViewIndex" [selectedDate]="selectedDate"
    [loading]="loading" [resources]="resources" [kendoSchedulerBinding]="events" (dateChange)="onDateChange($event)"
    (slotDblClick)="slotDblClickHandler($event)" (eventDblClick)="eventDblClickHandler($event)"
    (remove)="removeHandler($event)" style="height: 600px;"
    [workDayStart]="sessionSettings.schedulerStartTime" [workDayEnd]="sessionSettings.schedulerEndTime">

    <ng-template kendoSchedulerEventTemplate let-event="event">
        <div title="{{event.title}}" class="w-100 m-1">{{event.title}}</div>
    </ng-template>

    <kendo-scheduler-messages [dayViewTitle]="getViewText('DAY')" [multiDayViewTitle]="getViewText('MULTI_DAY')"
        [weekViewTitle]="getViewText('WEEK')" [timelineWeekViewTitle]="getViewText('WEEK_TIMELINE')"
        [agendaViewTitle]="getViewText('AGENDA')" [monthViewTitle]="getViewText('MONTH')"
        [workWeekViewTitle]="getViewText('WORK_WEEK')" showWorkDay="{{'SHOW-WORK-DAY' | translate}}"
        today="{{'TODAY' | translate}}" allDay="{{'ALL-DAY' | translate}}" showFullDay="{{'SHOW-FULL-DAY' | translate}}"
        nextTitle="{{'NEXT' | translate}}" deleteConfirmation="{{'CONFIRM-DELETE-EVENT' | translate}}"
        previousTitle="{{'PREVIOUS' | translate}}" deleteTitle="{{'DELETE' | translate}}"
        deleteDialogTitle="{{'PLEASE-CONFIRM' | translate}}">
    </kendo-scheduler-messages>

    <kendo-scheduler-day-view *ngIf="isViewEnabled('DAY')">
    </kendo-scheduler-day-view>

    <kendo-scheduler-multi-day-view *ngIf="isViewEnabled('MULTI_DAY')"
        [numberOfDays]="sessionSettings.schedulerMultiDays">
    </kendo-scheduler-multi-day-view>

    <kendo-scheduler-week-view *ngIf="isViewEnabled('WEEK')">
    </kendo-scheduler-week-view>

    <kendo-scheduler-work-week-view *ngIf="isViewEnabled('WORK_WEEK')"
        [workWeekStart]="sessionSettings.schedulerStartWeekDay" [workWeekEnd]="sessionSettings.schedulerEndWeekDay">
    </kendo-scheduler-work-week-view>

    <kendo-scheduler-month-view *ngIf="isViewEnabled('MONTH')" [eventHeight]="30">
    </kendo-scheduler-month-view>

    <kendo-scheduler-timeline-week-view *ngIf="isViewEnabled('WEEK_TIMELINE')">
    </kendo-scheduler-timeline-week-view>

    <kendo-scheduler-agenda-view *ngIf="isViewEnabled('AGENDA')" [numberOfDays]="sessionSettings.schedulerAgendaDays">
    </kendo-scheduler-agenda-view>
</kendo-scheduler>

<!--Event dialog-->
<app-event-edit-appointment [isNew]="isNew" [memberId]="memberId" [model]="editDataItem"
    (cancelling)="cancelChangesHandler()" (save)="saveChangesHandler()">
</app-event-edit-appointment>

<app-event-cancel-appointment [model]="cancelDataItem" (cancelling)="cancelCancelHandler()"
    (save)="saveCancelHandler()">
</app-event-cancel-appointment>